import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentTypeList extends Layout {
    layoutheaderEquipTypeList: LayoutHeader;
    sourceEquipmentType: DataSource;
    tableEquipmentType: Table;
}
